import { render, staticRenderFns } from "./examination-list.vue?vue&type=template&id=b106b32e&"
import script from "./examination-list.vue?vue&type=script&lang=js&"
export * from "./examination-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports